import React from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

export interface FilterMultiSelectOption {
  key: string;
  /** Texto usado no resumo (valor selecionado) do Select */
  name: string;
  /** Texto do item no menu, quando diferente de `name` (ex.: QR code com descrição) */
  menuLabel?: string;
}

interface FilterMultiSelectProps {
  labelId: string;
  label: string;
  options: FilterMultiSelectOption[];
  selected: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  minWidth?: number;
  /** Texto exibido quando nada está selecionado (padrão: "Todas") */
  allLabel?: string;
}

/**
 * Select múltiplo com checkbox, usado para os filtros de categoria/situação/prioridade/QR code —
 * estrutura idêntica nas 3 variantes de AdvancedFilters (mobile, compacta, expandida), só a
 * borda/wrapper ao redor mudava. Extraído de AdvancedFilters.tsx (F7).
 */
export const FilterMultiSelect: React.FC<FilterMultiSelectProps> = ({
  labelId,
  label,
  options,
  selected,
  onChange,
  disabled,
  fullWidth,
  minWidth,
  allLabel = 'Todas',
}) => {
  return (
    <FormControl
      size="small"
      {...(fullWidth ? { fullWidth: true } : {})}
      {...(minWidth !== undefined ? { sx: { minWidth } } : {})}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        multiple
        labelId={labelId}
        value={selected || []}
        onChange={(e) => onChange(e.target.value as string[])}
        label={label}
        {...(disabled !== undefined ? { disabled } : {})}
        renderValue={(sel) =>
          (sel as string[]).length
            ? (sel as string[]).map((k) => options.find((o) => o.key === k)?.name || k).join(', ')
            : allLabel
        }
      >
        {options.map((opt) => (
          <MenuItem key={opt.key} value={opt.key}>
            <Checkbox checked={(selected || []).indexOf(opt.key) > -1} size="small" />
            <ListItemText primary={opt.menuLabel ?? opt.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterMultiSelect;
